import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["arrow"];
  static values  = { panelId: String };

  connect() {
    this.panel = document.getElementById(this.panelIdValue);
    if (!this.panel) return;

    this._onShow = () => {
      this.arrowTarget.classList.remove("fa-chevron-right");
      this.arrowTarget.classList.add("fa-chevron-down");
    };

    this._onHide = () => {
      this.arrowTarget.classList.remove("fa-chevron-down");
      this.arrowTarget.classList.add("fa-chevron-right");
    };

    this.panel.addEventListener("show.bs.collapse",  this._onShow);
    this.panel.addEventListener("hide.bs.collapse",  this._onHide);
  }

  disconnect() {
    if (!this.panel) return;
    this.panel.removeEventListener("show.bs.collapse", this._onShow);
    this.panel.removeEventListener("hide.bs.collapse", this._onHide);
  }

  _getChecked(name) {
    const allBox = document.querySelector(`input[name="${name}"][value="all"]`);
    if (allBox && allBox.checked) return 'all';
    const vals = [...document.querySelectorAll(`input[name="${name}"]:checked`)]
      .map(el => el.value)
      .filter(v => v !== 'all');
    return vals.length ? vals : 'all';
  }

  _updateLabel(name) {
    const allBox = document.querySelector(`input[name="${name}"][value="all"]`);
    const label  = allBox && allBox.closest('.dropdown') && allBox.closest('.dropdown').querySelector('.ridp-fake-label');
    if (!label) return;
    if (allBox.checked) {
      label.textContent = 'All';
    } else {
      const count = document.querySelectorAll(`input[name="${name}"]:checked`).length;
      label.textContent = count === 0 ? 'All' : `${count} Selected`;
    }
  }


  keepOpen(event) {
    event.stopPropagation();
  }

  onCheckbox(event) {
    const cb    = event.target;
    const name  = cb.getAttribute('name');
    const allBox = document.querySelector(`input[name="${name}"][value="all"]`);
    const boxes  = document.querySelectorAll(`input[name="${name}"]`);
    const label  = cb.closest('.dropdown') && cb.closest('.dropdown').querySelector('.ridp-fake-label');

    if (cb.value === 'all') {
      boxes.forEach(b => b.checked = cb.checked);
      if (label) label.textContent = 'All';
    } else {
      if (allBox) allBox.checked = false;
      const checkedCount = [...boxes].filter(b => b.value !== 'all' && b.checked).length;
      if (label) label.textContent = checkedCount === 0 ? 'All' : `${checkedCount} Selected`;
    }
  }

  reset() {
    ['decision_code', 'verification_status', 'flow_type'].forEach(function(name) {
      document.querySelectorAll(`input[name="${name}"]`).forEach(cb => cb.checked = false);
      const allBox = document.querySelector(`input[name="${name}"][value="all"]`);
      if (allBox) allBox.checked = true;
      const label = document.querySelector(`#ridp-dd-${name} .ridp-fake-label`);
      if (label) label.textContent = 'All';
    });

    const hasAttachment = document.getElementById('filter_has_attachment');
    if (hasAttachment) hasAttachment.value = 'all';

    ['custom_datatable_date_from', 'custom_datatable_date_to'].forEach(function(id) {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

    const table = document.querySelector('.effective-datatable');
    if (table && $.fn.DataTable.isDataTable(table)) {
      $(table).DataTable().draw();
    }
  }
}
